class Sanitize {
    private constructor() {
        return
    }

    static string(str: string): string {
        return str.trim()
    }
}

export { Sanitize }
